import { acceptHMRUpdate, defineStore } from "pinia";
import { reactive } from "vue";

type KeyboardIdentifier = "arabic" | "russian";

interface KeyboardState {
  isOpen: boolean;
  posX: number;
  posY: number;
}

interface State {
  keyboards: Record<KeyboardIdentifier, KeyboardState>;
}

export const useFloatingKeyboardStore = defineStore("floatingKeyboard", () => {
  const state = reactive<State>({
    keyboards: {} as Record<KeyboardIdentifier, KeyboardState>
  });

  const getState = (keyboard: KeyboardIdentifier) => {
    if (state.keyboards[keyboard]) {
      return state.keyboards[keyboard];
    }

    state.keyboards[keyboard] = {
      isOpen: false,
      posX: 0,
      posY: 0
    };

    return state.keyboards[keyboard];
  };

  return {
    getState
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useFloatingKeyboardStore, import.meta.hot));
}
